<template>
  <div class="rate-template">
    <!-- 费率模板 -->
      <!-- <div class="title" >{{newAdd?'费率模板':'模板配置'}}</div> -->
      <!-- 返回列表 -->
      <!-- <div class="list-btn" @click="listBtnFun" v-show="!newAdd">返回列表</div> -->
    <el-row >
      <!-- 模板首页 -->
      <el-col :span="24" style="padding: 0 10px" >
        <el-card
          body-style="height: 90vh;padding:15px 20px"
          class="box-card devices-area"
          shadow="never"
        >
        <div class="top-search">
            <!-- 查询 -->
        <div :class="['search-box',{'search-foucs':inputFlag}]">
           <el-input placeholder="请输入名称" v-model.trim="tempName" class="input-with-select" @focus="focusFun" @blur="blurFun">
            <el-button slot="append" icon="el-icon-search" @click="searchFun"></el-button>
          </el-input>
        </div>
        <!-- 显示全部 -->
        <div class="hide-all">显示全部：<input type="checkbox" v-model="inputCheck"></div>
        <!-- 新增模板 -->
        <div class="add-template" @click="add_ed">新增</div>
        </div>

        <!-- <div class="mask" v-if="maskFlag">
          <div class="centent">
            <i class="el-icon-loading"></i>
           <div>数据加载中</div>
          </div>
        </div> -->
        
        <!-- 表格 -->
        <!-- v-show="!maskFlag" -->
     
      
              <el-table :data="tableData" :span-method="objectSpanMethod" 
               :header-cell-style="headerStyle"
               :cell-style="finalCellStyle"
                border  
               style="width: 100%; margin-top: 20px;margin-bottom:20px;font-size: 16px;border: 1px solid #dcdfe6"  
                height="800">
                 <el-table-column label="序号" width="60">
                      <template slot-scope="scope">
                      <span>{{ (scope.$index /3) + 1}}</span>
                </template>
                </el-table-column>
                  <el-table-column prop="temName" label="计费名称" width="180">
                </el-table-column>
                <el-table-column  prop="energyType" label="能源类型"  width="90">
                   <template slot-scope="scope">{{ scope.row.energyType | energyType }}</template>
                </el-table-column>
                 <el-table-column  prop="company" label="单位"  width="90">
                        <template slot-scope="scope">{{ scope.row.energyType | company }}</template>
                </el-table-column>
                 <el-table-column  prop="createTime" label="创建时间"  width="180">
                     <template slot-scope="scope">{{ scope.row.createTime | date_format }}</template>
                </el-table-column>
                 <el-table-column  prop="createTime" label="修改时间"  width="180">
                    <template slot-scope="scope">{{ scope.row.createTime | date_format }}</template>
                </el-table-column>
                 <el-table-column  prop="sectionName" label="阶梯名称"  width="160">
                      <template slot-scope="scope">{{ scope.row.sectionName | sectionNameFun }}</template>
                </el-table-column>
                 <el-table-column  prop="startMeter" label="开始值"  width="160">
                </el-table-column>
                 <el-table-column  prop="endMeter" label="结束值"  width="160">
                </el-table-column>
                 <el-table-column  prop="stepValue" label="单价（元）"  width="100">
                </el-table-column>

                 <el-table-column  label="状态"  width="90">
                    <template slot-scope="scope">
                         <el-switch v-model="scope.row.dataStatus" active-color="#52A1FF" @change="changeFun(scope.row.dataStatus,scope.row.temId)"></el-switch>
                         <!-- @change="changeFun(scope.row.defaultStatus,scope.row.temId)" -->
                      </template>
                </el-table-column>
                <el-table-column
                      label="操作"
                      width="206">
                      <template slot-scope="scope">
                        <el-button @click="edit_ed(scope.$index)" type="primary" size="small" >查看</el-button>
                        <el-button type="warning" size="small" @click="delOpen(scope.row.temId)">删除</el-button>
                      </template>
                    </el-table-column>
               </el-table>
         
        </el-card>
      </el-col>
    </el-row>
     <!-- 新增修改 -->
    <el-dialog v-dialogDrag :title="textMap[dialogStatus]" :close-on-click-modal='false' :visible.sync="dialogVisible"
      width="35%" center>
          <div class="con">
              <div class="name-type">
                 
                 <div class="name"> 计费名称： <input type="text" placeholder="请输入名称" v-model="temp.temName" :disabled="dialogStatus == 'edit'"> </div>
                  <div class="type">
                    能源类型： <el-select v-model="temp.energyType" placeholder="请选择" :disabled="dialogStatus == 'edit'">
                                <el-option
                                  v-for="item in options"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                                </el-option>
                              </el-select>
                  </div>
              </div>
              <div class="ladder">
                  <div class="item" v-for="(item,index) in ladderData" :key="index">
                    第{{index +1}}阶梯：<el-input v-model="item.startMeter" :disabled="true"></el-input>  <span class="heng">—</span> 
                    <el-input v-model="item.endMeter" :disabled="dialogStatus == 'edit' || index == 2" @input="endChangeFun(index)"></el-input>(kw-h) <span class="line"></span>
                    单价：<el-input v-model="item.stepValue" :disabled="dialogStatus == 'edit'"></el-input>(元/kw-h)
                  </div>
                   <!-- <div class="item">
                    第二阶梯：<el-input v-model="tempName" :disabled="true"></el-input>  <span class="heng">—</span> <el-input v-model="tempName" ></el-input>(kw-h) <span class="line"></span>
                    单价：<el-input v-model="tempName" ></el-input>(元/kw-h)
                  </div>
                 <div class="item">
                    第三阶梯：<el-input v-model="tempName" :disabled="true"></el-input>  <span class="heng">—</span> <el-input v-model="a" :disabled="true"></el-input>(kw-h) <span class="line"></span>
                    单价：<el-input v-model="tempName" ></el-input>(元/kw-h)
                  </div> -->
              </div>
          </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogStatus==='edit'?edit_fn('temp'):add_fn('temp')">确 定
          </el-button>
        </span>
      </template>
    </el-dialog>
      

  </div>
</template>
<script>
import {stepBillingTemp,saveStepTemplate,removeStepTemplateById,editStepEnableAndDisabled} from "../../../api/reading";
export default {
  data() {
    return {
      ladderOne:0,
         a:"以上",
         //表格数据
     
        tableData:[],
        //类型选项
          options: [{
          value: 'ELECTRIC',
          label: '电'
        }, {
          value: 'WATER',
          label: '水'
        }, {
          value: 'GAS',
          label: '气'
        }],
        //修改阶梯数据
        ladderData:[
           {
              startMeter:0,
              endMeter:0,
              stepValue:"1.00"
           },
           {
              startMeter:0,
              endMeter:0,
              stepValue:"1.00"
           },
           {
              startMeter:0,
              endMeter:"以上",
              stepValue:"1.00"
           }
        ],
        //新增阶梯数据
        ladderData1:[
           {
              startMeter:0,
              endMeter:"",
              stepValue:""
           },
           {
              startMeter:0,
              endMeter:"",
              stepValue:""
           },
           {
              startMeter:0,
              endMeter:"以上",
              stepValue:""
           }
        ],
        maskFlag:true,//遮罩层
        value: '',
        detailsDisable:false, //查看详情禁用全部
        tempName:"",//搜索框
        inputFlag:false, //输入框样式
        //首页模板数据
        temDate:null,
        newListData:null, //筛选搜索关键字
        inputCheck:true, //查看全部复选框
        temp:{},//新增模板
        dialogVisible: false,//控制弹窗
        //控制输入框是否必填
         rules: {
          temName: [
            { required: true, message: '请输入计费名称', trigger: 'blur' }
          ],
          energyType: [
            { required: true, message: '请选择能源类型', trigger: 'blur' }
          ],
          startMeter: [
            { required: true, message: '请输入计费单价', trigger: 'blur' }
          ],

        },
          dialogStatus: 'add',//新增/编辑
        //切换新增编辑
         textMap: {
          add: "新增阶梯计费",
          edit: "查看阶梯计费详情"
        },
         
   }
 },
  created(){
    this.getList();//阶梯计费模板数据
  
  },
  methods:{
 
   // 转换启用禁用
    tranStatus(data){
            data.forEach(item => {
              if(item.dataStatus == 'ENABLE'){
                item.dataStatus = true
              }else {
                  item.dataStatus = false
              }
            })
    },
    //表格样式
    headerStyle() {
		  return {
		    background: "#f3f8ff",
		    textAlign: "center",
		    color: "#909399",
		  	fontSize:"18px",
        fontWeight: "bold",
        borderColor:"#dcdfe6"
		  };
		},
     //表格样式
    finalCellStyle(row) {
		  let style = {
		    textAlign: "center",
		    color: "#191919",
		    fontSize:"18px",
         borderColor:"#dcdfe6"
			
		  };
		  return style;	 
		},

    //合并单元格
     objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      // console.log("columnIndex",columnIndex);
   
  
        if (columnIndex === 0 || columnIndex === 1|| columnIndex === 2|| columnIndex === 3|| columnIndex === 4|| columnIndex === 5 || columnIndex === 10|| columnIndex === 11) {
          if (rowIndex % 3 === 0) {
            return {
              rowspan: 3,
              colspan: 1
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0
            };
          }
          }
        },

     //启用禁用状态改变
    changeFun(val,temId){
      //true 启用 
      if(val){
        editStepEnableAndDisabled({dataStatusEnum:'ENABLE',id:temId}).then(data => {
            console.log("启用",data);
            if(data.code ==200){
              this.operationFun('success','启用成功')     
            }else {
                this.operationFun('error','启用失败')     
            }
        })
      }else {
           editStepEnableAndDisabled({dataStatusEnum:'DISABLE',id:temId}).then(data => {
            console.log("禁用",data);
            if(data.code ==200){
                this.operationFun('warning','已禁用!')  
             }else {
                this.operationFun('error','禁用失败')     
            }
            // console.log("禁用",data);
        })
      }
    },

    //操作提醒
     operationFun(types,describe){

          this.$message({
             type: types,
             message: describe,

          });
    },
    // 阶梯计费模板数据
      getList(){
        this.tableData = []
        stepBillingTemp().then(data => {
          // console.log("阶梯计费数据",data);
            // this.tableData = data.data
            let res = data.data
            //转换启用跟禁用
            this.tranStatus(res)
            this.handleData(res)
            // this.maskFlag = false
            //  this.tranStatus(this.temDate)
           }).catch(() => {
                //  this.maskFlag = false
           })

      },

      //处理表格数据
      handleData(data){
         for(let i = 0;i<data.length;i++){
        //  console.log(data[i]);
          //  this.tableData.push(data[i])
           data[i].stepSection.forEach(item => {
              // console.log(item);
                // console.log(data[i]);
                item['defaultStatus'] = data[i].defaultStatus
                item['dataStatus'] = data[i].dataStatus
                item['energyType'] = data[i].energyType
                item['temName'] = data[i].temName
                item['temId'] = data[i].temId
               this.tableData.push(item)
           })
         }
        //  console.log(this.tableData);
        
      },
    //查询
    searchFun(){
      //判断输入框是否为空
       this.tableData = []
      if(this.tempName == ''){
          this.operationFun('warning','输入框内容不能为空')     
          return;
      }
        this.inputCheck = false
        console.log(this.tempName);
        stepBillingTemp({temName:this.tempName}).then(data => {
             let res = data.data
            //转换启用跟禁用
            this.tranStatus(res)
            this.handleData(res)
           })
        
        
    },

    
    // 搜索框获得焦点
    focusFun(){
      this.inputFlag = true
    },
    // 搜索框失去焦点
    blurFun(){
        this.inputFlag = false
    },
    //新增单价计费
    add_ed(){
       this.temp = {}
      this.ladderData =  this.ladderData1
        this.dialogStatus = 'add';
        this.dialogVisible = true;
    },
    //编辑单价计费
    edit_ed(index){
      this.ladderData = []
        //  console.log(index);
         for(let i = index;i<index +3;i++){
          this.ladderData.push(this.tableData[i])
         }
         this.dialogStatus = 'edit';
        this.dialogVisible = true;
        this.temp = this.tableData[index]
    },
      // 确认添加
      // formName
      add_fn() {
        this.ladderData.forEach((item,index) => {
          item["sectionName"] = `第${index+1}阶梯`
        })
        this.ladderData[2].endMeter = -1
        var d = {
                "defaultStatus": "DEFAULT",
                "energyType": this.temp.energyType,
                "stepSection": this.ladderData,
                "temName": this.temp.temName
          }
           console.log("d",d);
     
            saveStepTemplate(d).then(data => {
              if (data.code == 200) {
                this.getList();
                this.dialogVisible = false;
                 this.$message({ showClose: true, message: '添加成功', type: 'success'});
                 this.ladderData = this.ladderData1
              } else {
                  this.$message.success('添加失败');
              }
                       
            })

    
      },
      // 查看详情
      edit_fn() {
          this.dialogVisible = false;
      },
       //结束值
    endChangeFun(index){
        //  console.log(index);
      
        this.ladderData[index + 1].startMeter = this.ladderData[index].endMeter
        
    },
    
    // 删除弹窗
     delOpen(ids) {
        this.$confirm('此操作将删除该模板, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
           removeStepTemplateById({id:ids}).then(data => {
            //  console.log("删除操作",data);
              if(data.code == 200){
                this.getList()
                this.operationFun('success','删除成功')
              }else {
                this.operationFun('error',`删除失败,${data.message}`)
              }
               
           })
        
        }).catch(() => {
            this.operationFun('info','已取消删除')       
        });
      },

      

      // 查看详情
      viewDetailsFun(id){
        console.log("模板id",id);
        
      },


  },
  watch:{
    
    //显示全部
    inputCheck(val){
      if(val){
        this.tempName = ""
        this.getList();//费率模板数据
      }
    },

    // 月区间数
    MonValue(newVal,oldVal){
       let num = newVal - oldVal
       if( num > 0){
          for(let i = 0;i<newVal-oldVal;i++){
               this.copyMonth = JSON.parse(JSON.stringify(this.sectionTem[0]))
               this.copyMonth.endMonthList = this.endMonthList
               this.monthTable.push(this.copyMonth)
          }
       }else {
           this.monthTable.splice(newVal)
       }
      //  this.endMonFun(newVal,oldVal)
      this.choiceMon()

    },
  },
  //过滤器
  filters:{
    //能源类型 ELECTRIC(电)  WATER(水) GAS(气)
    energyType(val){
      if(val == 'ELECTRIC'){
        return "电"
      }else if(val == 'WATER'){
        return "水"
      }else {
        return "气"
      }
    },
     //单位类型
      company(val){
      if(val == 'ELECTRIC'){
        return "kw·h"
      }else if(val == 'WATER'){
        return "t"
      }else {
        return "m³"
      }
    },
    //阶梯名称
    sectionNameFun(val){
      if(val == '第1阶梯'){
        return "第一阶梯"
      }else if(val == '第2阶梯'){
        return "第二阶梯"
      }else if(val == '第3阶梯'){
        return "第三阶梯"
      }else {
        return val
      }
    },
    // 转换时间戳
    "date_format":function (value) { //value就是插值的数据
      let date = new Date(value);
      let Y = date.getFullYear() + '-';
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      let D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + ' ';

      let h = (date.getHours() < 10 ? '0' + (date.getHours()) : date.getHours()) + ':';
      let m = (date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes()) + ':';
      let s = (date.getSeconds() < 10 ? '0' + (date.getSeconds()) : date.getSeconds());
      let strDate = Y + M + D + h + m + s;
       return strDate
    },
  }
};
</script>

<style lang="scss" scoped >
.con {
  width: 584px;
  padding-left: 20px;
  
  .name-type {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
   .name,.type {
     font-size: 16px;
   }
    input {
        width: 212px;
        height: 25px;
    }
    /deep/.el-input--suffix {
      width: 96px;
    }
    /deep/.el-input__inner {
      height: 37px;
    }
  }
  .ladder {
    width: 100%;
  
    .item {
        width: 100%;
        height: 36px;
        display: flex;
        align-items: center;
          font-size: 16px;
          margin-top: 20px;
        /deep/input ,/deep/.el-input{
          width: 90px !important;
          height: 100%;
          margin-right: 5px;
        }
        .heng {
          margin-right: 5px;
        }
        .line {
          display: inline-block;
          width: 1px;
          height: 20px;
          background-color: #CCCCCC;
          margin: 0px 20px;
        }
    }
  }
}

/deep/.el-input--suffix{
  display: flex;
  align-items: center;
  width: 350px;
}
/deep/.el-input.is-disabled .el-input__inner {
  color: #333;
}
// /deep/.el-input__inner {
//    border-top:0px ;
// }
/deep/.el-dialog__body {
    padding: 25px 30px 30px 0px;
}
/deep/.el-button--warning{
  border: 0px;
   background-color: #FF8058;
}
/deep/.el-button--primary{
  border: 0px;
     background-color: #52A1FF;
}

td {
  border: 1px solid #999999!important;
}

/deep/tr:nth-of-type(6n+4){
  background-color: #f2f2f2;
}
/deep/tr:nth-of-type(6n+5){
  background-color: #f2f2f2;
}
/deep/tr:nth-of-type(6n+6){
  background-color: #f2f2f2;
}


.rate-template 

   
      {
        position: relative;
        box-sizing:border-box;
        background-color: #edf2f9;
    
    
        
        //标题
        .title {
          height:25px;
          width:100px;
          color: #999;
          font-size: 18px;
          font-weight: 700;
          margin: 0px 0px 8px 0px;
          padding-left: 20px;
          padding-top: 5px;
        }
     
        .top-search {
          display: flex;
          align-items: center;
          .add-template {
            width: 88px;
            height: 32px;
            text-align: center;
            line-height: 32px;
            color: #fff;
            background-color: #52A1FF;
            border-radius: 5px;
            cursor: pointer;
          }
          .hide-all {
            display: flex;
            align-items: center;
            margin: 0px 40px 0px 20px;
          }
        }
        // 查询
         /deep/.search-foucs .el-input__inner{
            background-color: #e4f1ff;
            color: #000;
            
          }
        .search-box { 
          .el-input {
            width: 350px;
          }
          /deep/.el-input__inner {
              height: 36px;
           
          }
          /deep/.el-input__inner:hover {
            border-color: #409eff;
          }
          /deep/.el-input-group__append {
            background-color: #409eff;
              color: #fff;
              font-size: 15px;
              border: 1px solid #409eff;
          }
        }
        .mask {
          position: absolute;
          top: 150px;
          left: 10px;
          width: 1700px;
          height: 600px;
          display: flex;
          justify-content: center;
          align-items: center;
            .centent {
              text-align: center;
            }
          i {
            font-size: 50px;
            color: #52A1FF;
            font-weight: 700;
            margin-bottom: 10px;
          }
        }
        //表格
    


       
      }
</style>
